import { render } from "./MassMediaCategoryCard.vue?vue&type=template&id=a5525544"
import script from "./MassMediaCategoryCard.vue?vue&type=script&lang=js"
export * from "./MassMediaCategoryCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__